import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { PropsWithChildren } from 'react';

export const IconTooltip = ({ children }: PropsWithChildren<{}>) => (
    <Tooltip title={children} placement="right">
        <IconButton color="primary">
            <InfoOutlinedIcon fontSize="small" />
        </IconButton>
    </Tooltip>
);
